export enum formType {
  one = 1,
  three = 3,
  six = 6,
  Two = 2
}
